import DpBillsReportActions from "@frameworks/web/redux/actions/Reports/DpBills/DpBillsReport";
export default () => {
    return {
        dpBillReport: new DpBillsReportActions(),
    };
};
